export function debounce(func, wait) {
  let timeout;
  return function(...args) {
    const context = this;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}

export function formatDateTime(dateTime) {
  if (!dateTime) return ''
  const date = new Date(dateTime)
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  return `${month}-${day} ${hours}:${minutes}`
}

export function formatTime(dateTime) {
  if (!dateTime) return ''
  const date = new Date(dateTime)
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}

/**
 * 兼容 iOS 及部分 WebView 的日期解析：
 * 后端返回 "2026-09-12 18:00:00"（带空格），iOS WKWebView 部分版本无法解析，
 * 统一转成 "2026/09/12 18:00:00"（各平台均可解析）
 */
export function parseDate(dateTime) {
  if (!dateTime) return null
  return new Date(String(dateTime).replace(/-/g, '/'))
}